import axios from 'axios';
import '../services/GlobalVariables';

export const DEFAULT_POS_ORDER_TYPE_SETTINGS = {
  businessProfile: 'restaurant',
  enableForwardInvoices: false,
  forwardInvoicePrinterName: '',
  forwardInvoicePrinterIP: '',
  forwardInvoicePrinterPort: 9100,
  forwardInvoicePrinterPaperMm: 80,
  autoPrintForwardInvoice: false,
  enableDineIn: true,
  enableTakeaway: true,
  enableDelivery: true,
  enableFoodpanda: true,
  enableDeleteAllSales: false,
  includeDeliveryAmountInCash: false,
  allowDecimalPayments: true,
  restaurantOrderModeOrder: ['dinein', 'takeaway', 'delivery'],
};

const normalizeOrderModeOrder = (value) => {
  const allowed = ['dinein', 'takeaway', 'delivery'];
  return Array.isArray(value) && value.length === 3 && allowed.every((key) => value.includes(key)) ? value : allowed;
};

const API_URL = `${global.SET_API_URL}posOrderTypeSettings`;

const normalizeSettings = (settings = {}) => ({
  businessProfile: ['restaurant', 'bakery', 'supermart', 'medical_store'].includes(settings.businessProfile)
    ? settings.businessProfile
    : DEFAULT_POS_ORDER_TYPE_SETTINGS.businessProfile,
  enableForwardInvoices: settings.enableForwardInvoices === true,
  forwardInvoicePrinterName: String(settings.forwardInvoicePrinterName || '').trim(),
  forwardInvoicePrinterIP: String(settings.forwardInvoicePrinterIP || '').trim(),
  forwardInvoicePrinterPort: Number(settings.forwardInvoicePrinterPort) || 9100,
  forwardInvoicePrinterPaperMm: Number(settings.forwardInvoicePrinterPaperMm) === 58 ? 58 : 80,
  autoPrintForwardInvoice: settings.autoPrintForwardInvoice === true,
  enableDineIn: settings.enableDineIn !== false,
  enableTakeaway: settings.enableTakeaway !== false,
  enableDelivery: settings.enableDelivery !== false,
  enableFoodpanda: settings.enableFoodpanda !== false,
  enableDeleteAllSales: settings.enableDeleteAllSales === true,
  includeDeliveryAmountInCash: settings.includeDeliveryAmountInCash === true,
  allowDecimalPayments: settings.allowDecimalPayments !== false,
  restaurantOrderModeOrder: normalizeOrderModeOrder(settings.restaurantOrderModeOrder),
});

export const fetchPosOrderTypeSettings = async () => {
  const response = await axios.get(API_URL);
  return normalizeSettings(response.data?.data || DEFAULT_POS_ORDER_TYPE_SETTINGS);
};

export const savePosOrderTypeSettings = async (settings) => {
  const response = await axios.post(API_URL, normalizeSettings(settings));
  return normalizeSettings(response.data?.data || settings);
};
